$(function () {

    $('footer h2').on('click', function () {
        const element = $(this).next('ul')

        $('footer ul').removeClass('active');
        element.addClass('active')

    })

})